export const trimWithSingleSpace = (str: string) =>
  str.trim().replace(/\s+/g, ' ');
